/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  RiLockLine, 
  RiEyeLine, 
  RiEyeOffLine,
  RiMailLine,
  RiShieldCheckLine,
  RiDashboardLine,
  RiBarChartLine,
} from 'react-icons/ri';
import toast from 'react-hot-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetSent, setResetSent] = useState(false);

  const navigate = useNavigate();
  const { login, resetPassword, currentUser } = useAuth();

  useEffect(() => {
    if (currentUser) {
      navigate('/admin/dashboard');
    }
  }, [currentUser, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Please fill in all fields');
      return;
    }

    setIsLoading(true);
    
    const result = await login(email, password);
    
    setIsLoading(false);
    
    if (result.success) {
      toast.success('Login successful!');
    } else {
      toast.error(result.error || 'Login failed');
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (!resetEmail) {
      toast.error('Please enter your email address');
      return;
    }

    setIsLoading(true);
    
    const result = await resetPassword(resetEmail);
    
    setIsLoading(false);
    
    if (result.success) {
      setResetSent(true);
      toast.success(result.message || 'Password reset link sent!');
    } else {
      toast.error(result.error || 'Failed to send reset link');
    }
  };

  const handleNavigateToRegister = () => {
    navigate('/admin/register');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="logo">
            <img src="/assets/img/logo.png" alt="Farmo South Sudan" />
            <div className="logo-text">
              <h1>FARMO SOUTH SUDAN</h1>
            </div>
          </div>
          
          {!isForgotPassword ? (
            <>
              <p className="subtitle">Sign in to manage Farmo South Sudan website</p>
            </>
          ) : (
            <>
              <h2>Reset Password</h2>
              <p className="subtitle">Enter your email to receive a reset link</p>
            </>
          )}
        </div>

        {!isForgotPassword ? (
          <>
            <form onSubmit={handleLogin} className="login-form">
              <div className="form-group">
                <label htmlFor="email">
                  <RiMailLine /> Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@farmosouthsudan.com"
                  required
                  disabled={isLoading}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <div className="label-row">
                  <label htmlFor="password">
                    <RiLockLine /> Password
                  </label>
                  <button
                    type="button"
                    className="forgot-link"
                    onClick={() => setIsForgotPassword(true)}
                    disabled={isLoading}
                  >
                    Forgot Password?
                  </button>
                </div>
                <div className="password-input">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    disabled={isLoading}
                    className="form-input"
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={isLoading}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                  </button>
                </div>
              </div>

              <div className="form-options">
                <label className="checkbox">
                  <input type="checkbox" />
                  <span>Remember me</span>
                </label>
                <div className="login-redirect">

          </div>
              </div>

              <button 
                type="submit" 
                className="btn btn-primary btn-block"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span> Signing in...
                  </>
                ) : (
                  'Sign In'
                )}
              </button>
              <div>
                            <p>
              Don't have an account?{' '}
              <button
                type="button"
                className="link-button"
                onClick={handleNavigateToRegister}
                disabled={isLoading}
              >
                Sign up here
              </button>
            </p>
              </div>
            </form>
          </>
        ) : (
          <form onSubmit={handleResetPassword} className="reset-form">
            {resetSent ? (
              <div className="reset-success">
                <RiShieldCheckLine className="success-icon" />
                <h3>Check Your Email</h3>
                <p>We've sent a password reset link to <strong>{resetEmail}</strong></p>
                <div className="button-group">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      setIsForgotPassword(false);
                      setResetSent(false);
                    }}
                  >
                    Back to Login
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="form-group">
                  <label htmlFor="reset-email">
                    <RiMailLine /> Email Address
                  </label>
                  <input
                    id="reset-email"
                    type="email"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                    placeholder="Enter your registered email"
                    required
                    disabled={isLoading}
                    className="form-input"
                  />
                </div>

                <div className="button-group">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-block"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner"></span> Sending...
                      </>
                    ) : (
                      'Send Reset Link'
                    )}
                  </button>
                  
                  <button
                    type="button"
                    className="btn btn-text"
                    onClick={() => setIsForgotPassword(false)}
                    disabled={isLoading}
                  >
                    Back to Login
                  </button>
                </div>
              </>
            )}
          </form>
        )}

        <div className="login-footer">
          <p className="support">
            Need help? <a href="mailto:support@farmosouthsudan.com">Contact support</a>
          </p>
          <p className="copyright">
            &copy; {new Date().getFullYear()} Farmo South Sudan Co.Ltd
          </p>
        </div>
      </div>

      <div className="login-sidebar">
        <div className="sidebar-content">
          <div className="sidebar-header">
            <h3>Powerful Admin Dashboard</h3>
            <p>Manage every aspect of your website</p>
          </div>
          
          <div className="features-list">
            <div className="feature-item">
              <RiDashboardLine className="feature-icon" />
              <div>
                <h4>Complete Control</h4>
                <p>Manage products, sponsors, and content easily</p>
              </div>
            </div>
            
            <div className="feature-item">
              <RiBarChartLine className="feature-icon" />
              <div>
                <h4>Real-time Analytics</h4>
                <p>Track website performance and user engagement</p>
              </div>
            </div>
            
            <div className="feature-item">
              <RiShieldCheckLine className="feature-icon" />
              <div>
                <h4>Secure & Reliable</h4>
                <p>Enterprise-grade security with SQLAlchemy backend</p>
              </div>
            </div>
          </div>
          
          <div className="security-note">
            <RiShieldCheckLine />
            <p>Your data is protected with end-to-end encryption</p>
          </div>
          
          <div className="registration-info">
            <h4>Need Access?</h4>
            <p>Contact the administrator to create an account or use the demo credentials to explore.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;